import { render, staticRenderFns } from "./AdjuntoDataCO.vue?vue&type=template&id=05e88cc2&"
import script from "./AdjuntoDataCO.vue?vue&type=script&lang=js&"
export * from "./AdjuntoDataCO.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports